// Shared <head> meta tag setter for the public-facing pages.
//
// Wraps react-helmet-async so each page can declare its own title,
// description, and canonical URL with one component instead of seven
// repetitive <meta> tags. Open Graph and Twitter tags get the same
// title/description so social-share previews match the page they
// represent (otherwise every shared URL would show the homepage card).
//
// Default OG image and site name still come from client/index.html;
// per-page tags override only what changes per route.
//
// Used only on PUBLIC pages (Landing, Login, Register, Terms, Privacy).
// Authenticated pages are noindex by virtue of being behind a login
// and don't need SEO chrome.

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_ORIGIN = 'https://www.hoophero.net';

const PageMeta = ({ title, description, path = '/' }) => {
  const url = `${SITE_ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default PageMeta;
